import React, {Component} from "react";
import styled, {keyframes} from "styled-components";
import {WhenInView} from "../Tools/WhenInView";

import {
  LargeTitle,
  InfoParagraph,
  SmallMargin,
  lightest,
  ContainWPadding,
  SmallTitle,
  primary,
  ReadMore,
  Marked
} from "../Tools/Variables";
import ControllImg from "../Images/controller.svg";

import springsBgImg from "../Images/springs.svg";
import springsFgImg from "../Images/threads.svg";
import FirmFlex from "../Images/FirmFlex.png";
import DuoLine from "../Images/DuoLine.png";

const FlexContainer = styled.div `
  padding-top: 70px;
  padding-bottom: 40px;
  display: flex;
  width: 100%;
  max-width: 600px;
  min-height: 250px;
  @media screen and (max-width: 550px) {
    flex-direction: column;
  }
`;

const ControllerFlex = styled.div `
  position: relative;
  transition: 1s ease-out;
  height: 100%;
  width: auto;
  display: flex;
  z-index: 20;
  flex-shrink: 0;
  transform: ${props => props.animate
  ? "translateY(-142px)"
  : "translateY(10px)"};
  @media screen and (max-width: 550px) {
    height: 40px;
  }
`;

const ControllContainer = styled.img `
  position: relative;
  display: block;
  height: 250px;
  width: auto;
  flex-shrink: 0;
`;

const BedBg = styled.div `
  position: relative;
  background: white;
  background-size: cover;

  border-top: 1px solid #444;
`;

const BgOverlay = styled.div `
  position: absolute;
  background: white;
  opacity: 0.5;
  height: 100%;
  width: 100%;
`;

const ShadowOverlay = styled.div `
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
`;

export const AnimateBed = keyframes `

  0% {

    transform: scaleY(1.1);
  }
  5% {

    transform: scaleY(1.1);
  }
  
  45% {

    transform: scaleY(1);
  }
  55% {

    transform: scaleY(1);
  }
  
  95% {
    transform: scaleY(0.9);
    
  }
  100% {
    transform: scaleY(0.9);
    
  }
}
`;

export const AnimateBtnMinus = keyframes `

  0% {
    opacity:0;
    transform: scale(0);
  }
  1% {
    
    opacity:1;
    transform: scale(0);
  }
  22% {
    
    opacity:0;
    transform: scale(1.8);
  }
  
  
  23% {
    opacity:0;
    transform: scale(0);
  }
  24% {
    
    opacity:1;
    transform: scale(0);
  }
  45% {
    opacity:0;
    transform: scale(1.8);
  }
  

}
`;
export const AnimateBtnPlus = keyframes `

  50% {
    transition:1s;
    opacity:0;
    transform: scale(0);
  }
  51% {
    
    opacity:1;
    transform: scale(0);
  }
  72% {
    
    opacity:0;
    transform: scale(1.8);
  }
  
  
  73% {
    opacity:0;
    transform: scale(0);
  }
  74% {
    
    opacity:1;
    transform: scale(0);
  }
  95% {
    opacity:0;
    transform: scale(1.8);
  }
  

}
`;

const Plus = styled.div `
  opacity: 0;
  z-index: 20;
  position: absolute;
  top: 109px;
  left: 32px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: ${primary};
  animation: ${AnimateBtnPlus} 8s ease-in-out infinite;
`;

const Minus = styled.div `
  opacity: 0;
  background: ${primary};
  border-radius: 50%;
  z-index: 20;
  position: absolute;
  top: 79px;
  left: 32px;
  height: 40px;
  width: 40px;
  animation: ${AnimateBtnMinus} 8s ease-in-out infinite;
`;

const SpringsContainer = styled.div `
  height: 100%;
  width: 100%;
  position: relative;
  margin-right: 5%;
  flex: 0 1 auto;
  background: ${lightest};
  box-sizing: border-box;
  @media screen and (max-width: 550px) {
    margin-right: 0%;
  }
`;

const SpringsBg = styled.img `
  transform: scaleY(1);
  transition: 0.7s ease-in-out;
  position: relative;
  width: 100%;

  flex: 0 1 auto;
  height: auto;
  transform-origin: top;
  animation: ${props => props.animate
  ? AnimateBed + " 4s ease-in-out infinite alternate"
  : ""};
`;

const SpringsFg = SpringsBg.extend `
  position: absolute;
  top: 0;
  left: 0;
  animation: none;
`;

const MoreInfoFlex = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: ${props => (props.column
  ? ""
  : "center")};
  flex-direction: ${props => (props.column
  ? "column"
  : "row")};
  @media screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

const MoreImg = styled.img `
  box-sizing: border-box;
  margin: 40px;
  width: 300px;
  flex: 0 0 auto;
`;
const MoreText = styled.div `
  max-width: 600px;
`;
class Controller extends Component {
  state = {
    animateBed: true
  };

  moreFirm = () => {
    this.setState({animateBed: false});
  };

  render() {
    return (
      <React.Fragment>
        <ContainWPadding>
          <SmallMargin/>
          <SmallMargin/>
          <div style={{
            maxWidth: 500
          }}>
            <SmallTitle>Lyxig säng med exceptionell följsamhet</SmallTitle>
            <SmallMargin/>
            <LargeTitle>PERFEKT FASTHET – MED BARA ETT KNAPPTRYCK</LargeTitle>
            <SmallMargin/>

            <InfoParagraph style={{}}>
              Med fjärrkontrollen som medföljer Modilects premiumsäng kan du med ett enkelt
              knapptryck, när du vill, steglöst justera dess fasthet. Resultatet är
              exceptionellt – rätt säng, varje natt.
            </InfoParagraph>
          </div>
          <div style={{}}>
            <ReadMore>
              <MoreInfoFlex>
                <MoreText>
                  <SmallTitle>Om tekniken</SmallTitle>
                  <SmallMargin/>
                  <InfoParagraph style={{}}>
                    Du som kund vill vakna utsövd, vi som företag vill bygga världens komfortablaste
                    premiumsäng. Genom att förena mångårig hantverkserfarenhet med den senaste
                    teknologin kan vi bygga handgjorda kvalitetssängar med den absolut bästa
                    komforten. Med den tydliga målbilden har vi sedan gjort banbrytande innovationer
                    för att ta den konventionella fjädersängen in i 2000-talet.
                    <SmallMargin/>
                    Du som kund skall inte behöva bry dig om vilken teknik som används i sängen. Men
                    då valet av säng är en stor investering och löftena från oss sängfabrikanter är
                    många vill vi mer noggrant beskriva våra innovationer – så du som kund förstår
                    skillnaden mellan vår justerbara fasthet och andra som använder samma uttryck
                    för annan teknik.
                  </InfoParagraph>
                </MoreText>
                <div/>
              </MoreInfoFlex>
              <SmallMargin/>
              <SmallMargin/>
              <MoreInfoFlex>
                <MoreText>
                  <SmallTitle>FirmFlex</SmallTitle>
                  <SmallMargin/>
                  <InfoParagraph style={{}}>
                    FirmFlex är en funktion som justerar fastheten i en specifik zon i sängen. En
                    sängs följsamhet är avgörande för komforten. Sängen måste exempelvis ge stöd i
                    svanken och några centimeter därifrån komprimeras vid höften.
                    <SmallMargin/>
                    Den patentsökta lösningen med justerbar fasthet bygger på att varje enskild
                    fjäder har ett individuellt mothåll på toppen. Det innebär att fjädrarnas
                    möjlighet att röra sig fritt för att uppnå maximal följsamhet inte påverkas då
                    vi varierar fastheten från extra mjuk till extra fast
                    <Marked>
                      Om du hör uttrycket "justerbar fasthet" från någon annan,
                    </Marked>
                    fråga om fjädrarna är individuellt förankrade, annars riskerar du risken att får
                    en stel säng utan följsamhet.
                    <SmallMargin/>
                    Vår lösning innebär också att du när du vill enkelt kan justera fastheten med en
                    fjärrkontroll. Inte att du skall bädda upp sängen, riva bort bäddmadrassen
                    manuellt, byta ut moduler med fjädrar eller krypa under sängen för att dra i
                    reglage. Kort och gott, "äkta" justerbar fasthet för maximal komfort.
                  </InfoParagraph>
                </MoreText>
                <div>
                  <MoreImg src={FirmFlex} alt="Firm Flex"/>
                </div>
              </MoreInfoFlex>
              <SmallMargin/>
              <SmallMargin/>
              <MoreInfoFlex column>
                <MoreText>
                  <SmallTitle>DuoProfile</SmallTitle>
                  <SmallMargin/>
                  <InfoParagraph style={{}}>
                    I de flesta av våra justerbara sängar har vi två moduler med FirmFlex, en kring
                    svank/höft och en vid axelpartiet. Med DuoProfile skapas en optimal
                    belastningslinje längs dessa två zoner. Lösningen med den steglösa övergången
                    mellan modulerna är unik och patentsökt.
                    <Marked>unik och patentsökt.</Marked>
                  </InfoParagraph>
                </MoreText>
                <div>
                  <MoreImg src={DuoLine} alt="Duo Line"/>
                </div>
              </MoreInfoFlex>

              <SmallMargin/>
              <SmallMargin/>
              <SmallMargin/>
            </ReadMore>
            <SmallMargin/>
          </div>
        </ContainWPadding>
        <WhenInView>
          {({isInView}) => (
            <BedBg>
              <BgOverlay/>

              <ContainWPadding>
                <FlexContainer>
                  <SpringsContainer>
                    <SpringsBg animate={this.state.animateBed} src={springsBgImg}/>
                    <SpringsFg src={springsFgImg}/>
                    <ShadowOverlay/>
                  </SpringsContainer>
                  <ControllerFlex animate={isInView}>
                    <Plus onClick={this.moreFirm}/>
                    <Minus/>
                    <ControllContainer src={ControllImg}/>
                  </ControllerFlex>
                </FlexContainer>
              </ContainWPadding>
            </BedBg>
          )}
        </WhenInView>
      </React.Fragment>
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/Home/Controller2.js